import React from 'react';

const NextPreviousContainer = () => {
  return (
    <></>
  );
};

export default NextPreviousContainer;
